import { Link } from 'react-router-dom';
import PawPrint from './PawPrint';

const Footer = () => {
  return (
    <footer className="bg-[#1B4332] text-white py-12 px-4 sm:px-6" style={{ marginTop: 0 }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <PawPrint className="w-8 h-8" color="#BFDB38" />
              <span className="text-2xl font-black" style={{ fontFamily: 'Nunito, sans-serif' }}>PurrCheck</span>
            </div>
            <p className="text-white/80 text-sm">
              Know what's in your cat's food — and what's actually safe.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Product</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/pricing" className="text-white/80 hover:text-[#BFDB38] transition-colors">Pricing</Link></li>
              <li><Link to="/affiliates" className="text-white/80 hover:text-[#BFDB38] transition-colors">Recommended Products</Link></li>
              <li><Link to="/subscription" className="text-white/80 hover:text-[#BFDB38] transition-colors">Subscription</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="text-white/80 hover:text-[#BFDB38] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-white/80 hover:text-[#BFDB38] transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy" className="text-white/80 hover:text-[#BFDB38] transition-colors">Refund Policy</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>Contact</h4>
            <ul className="space-y-2 text-sm">
              <li className="text-white/80">
                <a href="mailto:support@purrcheck.com" className="hover:text-[#BFDB38] transition-colors">support@purrcheck.com</a>
              </li>
              <li className="text-white/80">
                <a href="mailto:privacy@purrcheck.com" className="hover:text-[#BFDB38] transition-colors">privacy@purrcheck.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center">
          <p className="text-white/60 text-sm">
            &copy; {new Date().getFullYear()} PurrCheck. All rights reserved.
          </p>
          <p className="text-white/40 text-xs mt-2">
            PurrCheck is an educational tool and not a substitute for professional veterinary advice.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
